// extracted by mini-css-extract-plugin
export var card = "_4n-0";
export var content = "_4n-1";
export var contentLoading = "_4n-2";